import React, { Component } from "react";

import "./Footer.scss";

import bottom from "../Images/H0_Footer-14.png";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <img 
          style={{cursor: "pointer"}}
          src={bottom} alt="Footer" 
          onClick={() => (window.location = "https://www.bosplus.be/nl/voor-leerkrachten")}
        />
        {false && (
          <div className="footer_content">
            <span className="bos">
              BOS+ is een Vlaamse organisatie die zich specifiek inzet voor
              bosbehoud, beter bos en meer bos in Vlaanderen en de wereld.
            </span>
            <div className="address">
              <span className="address_left">
                BOS+ Vlaanderen vzw <br />
                BTW: BE0411 088 374 <br />
                <br />
                <br />
                BOS+ Tropen vzw <br />
                BTW: BE0479 222 461 <br />
              </span>
              <span className="address_right">
                +32 (0)9 264 90 50 <br />
                Geraardsbergsesteenweg 267 <br />
                9090 Gontrode <br />
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Footer;
